/**
 * Human string from a SuperFetch result for Notification descriptions. On
 * transport failure SuperFetch returns { errors: 'Server Error', error: <Error> }
 * (no statusCode) — the raw Error object must never reach JSX (React throws on
 * object children).
 */
const describeApiError = (res, fallback = 'Request failed') => {
	if (typeof res?.error === 'string' && res.error) return res.error;
	if (typeof res?.errors === 'string' && res.errors) return res.errors;
	if (typeof res?.error?.message === 'string') return res.error.message;
	if (typeof res?.info === 'string' && res.info) return res.info;
	if (typeof res?.message === 'string' && res.message) return res.message;
	return fallback;
};

export default describeApiError;
